<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <loginSvgWhite v-if="imgUrl === 'Light'" />
          <loginSvgDark v-if="imgUrl === 'Dark'" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-col>
            <b-img
              right
              class="mb-1 mb-sm-0"
              height="60"
              width="auto"
              src="../assets/animations/gvoz-1920.svg"
            />
          </b-col>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-card-title
                title-tag="h2"
                class="font-weight-bold mb-1"
              >
                Bem vindo! ✌️
              </b-card-title>
              <b-form-group
                label="CPF"
                label-for="login-cpg"
              >
                <validation-provider
                  v-slot="{ errors }"
                  name="CPF"
                  rules="required"
                >
                  <the-mask
                    v-model="userCpf"
                    class="form-control"
                    :mask="['###.###.###-##', '##.###.###/####-##']"
                    placeholder="000.000.000-00"
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >O campo CPF é obrigatório!</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Senha</label>
                  <b-link :to="{name:'auth-forgot-password-v2'}">
                    <small>Esqueceu a senha?</small>
                  </b-link>
                </div>
                <validation-provider
                  v-slot="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >O campo Senha é obrigatório!</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Lembra - me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="segundosBloqueio > 0"
                @click="validationForm"
              >
                {{ segundosBloqueio > 0 ? `Tente novamente em ${tempoBloqueio}` : 'Entrar' }}
              </b-button>
            </b-form>
          </validation-observer>
          <b-card-text class="mt-1">
            Versão 1.31.01
          </b-card-text>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { TheMask } from 'vue-the-mask'

import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
// import Cleave from 'vue-cleave-component'
import loginSvgWhite from '../assets/animations/LoginAnimationWhite.vue'
import loginSvgDark from '../assets/animations/LoginAnimationDark.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    loginSvgWhite,
    loginSvgDark,
    TheMask,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userCpf: '',
      sideImg: '',
      mask: {
        cpfCnpj: {
          delimiters: ['.', '.', '-'],
          blocks: [3, 3, 3, 3],
          uppercase: true,
        },
      },
      // validation rulesimport store from '@/store/index'
      required,
      segundosBloqueio: 0,
      timerBloqueio: null,
    }
  },
  computed: {
    tempoBloqueio() {
      const minutos = Math.floor(this.segundosBloqueio / 60)
      const segundos = String(this.segundosBloqueio % 60).padStart(2, '0')
      return `${minutos}:${segundos}`
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return 'Dark'
      }
      return 'Light'
    },
  },
  mounted() {
    // Aviso deixado pelo interceptor de 401 ou pela troca de senha
    const aviso = sessionStorage.getItem('avisoLogin')
    if (aviso) {
      sessionStorage.removeItem('avisoLogin')
      this.$toast({
        component: ToastificationContent,
        props: {
          title: aviso,
          icon: 'InfoIcon',
          variant: 'warning',
        },
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timerBloqueio)
  },
  methods: {
    validationForm() {
      if (this.segundosBloqueio > 0) {
        return
      }
      this.userCpf = this.userCpf.replace(/[^0-9]/g, '')
      this.$store.dispatch('auth/login', { cpf: this.userCpf, password: this.password }).catch(error => {
        if (localStorage.getItem('token')) {
          return
        }
        const { status, data = {}, headers = {} } = error.response || {}
        if (status === 429) {
          this.bloquearLogin(this.segundosRetry(headers['retry-after'], data.mensagem))
          this.toastErro(data.mensagem || 'Muitas tentativas de login. Tente novamente mais tarde.')
          return
        }
        this.toastErro('Credenciais Inválidas')
      })
    },
    segundosRetry(retryAfter, mensagem) {
      const segundos = Number(retryAfter)
      if (segundos > 0) {
        return segundos
      }
      // Sem acesso ao header (CORS), usa os minutos informados na mensagem
      const minutos = /(\d+)\s*minuto/.exec(mensagem || '')
      return minutos ? Number(minutos[1]) * 60 : 60
    },
    bloquearLogin(segundos) {
      clearInterval(this.timerBloqueio)
      this.segundosBloqueio = segundos
      this.timerBloqueio = setInterval(() => {
        this.segundosBloqueio -= 1
        if (this.segundosBloqueio <= 0) {
          clearInterval(this.timerBloqueio)
        }
      }, 1000)
    },
    toastErro(title) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: 'EditIcon',
          variant: 'danger',
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
